import { TeachingHallComment } from '../../../lib/types/models/ol/teaching-hall-comment/teaching-hall-comment'
import { TeachingHallCommentInput } from '../../../lib/types/models/ol/teaching-hall-comment/teaching-hall-comment-input'
import { API, constructApiUrl } from '../../apis.config'
import { restApiClient } from '../../rest-api-client'

export const createTeachingHallComment = async (
  input: TeachingHallCommentInput & { teachingHallId: number }
) => {
  const { teachingHallId, ...data } = input

  return restApiClient
    .url(constructApiUrl(API.teachingHallComments.create.url, { teachingHallId }))
    .post<TeachingHallComment, TeachingHallCommentInput>(data)
}
